@use '@/scss/underscore' as _;

.notice {
  margin-top: _.unit(4);
}
